import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { getListForm } from '../../redux/actions/forms';
import { getService, updateService } from '../../redux/actions/serviceBiller';
import { getListAggregator } from '../../redux/actions/aggregator';

import ServiceUpdate from '../ServiceCreate/ServiceCreate.page';

const mapStateToProps = state => ({
  listForm: state.allbiller.listForm,
  listAggregator: state.allbiller.listAggregator,
  service: state.allbiller.service,
  loading: state.allbiller.loading,
});

const mapDispatchToProps = {
  getListForm,
  getListAggregator,
  getService,
  updateService,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ServiceUpdate));
